import { useContext, useState } from 'react'
import { useEffectOnce, useUnmount } from 'react-use'

import { v4 } from 'uuid'
import { usePanel } from 'player/src/modules/panel/edits/store'
import { usePanelAsideStore } from 'player/src/modules/panel-aside/edits/store'

import { getDisplayType, getTotalTimeSpent } from './utils'

import { ContextShell } from '../../../../../../packages/web-app-shell/src'

export interface UseEvent {
  setTotalListenTime: React.Dispatch<React.SetStateAction<number>>
  totalListenTime: number
  setStartTime: React.Dispatch<React.SetStateAction<number | null>>
  startTime: number | null
}

interface UseEventMixerProps {
  taskId: string
}

export const useEventMixer = ({ taskId }: UseEventMixerProps): UseEvent => {
  const {
    event: { sendEventPostHog }
  } = useContext(ContextShell)

  const [visitedAt, setVisitedAt] = useState<Date>(new Date())

  useEffectOnce(() => {
    setVisitedAt(new Date())
  })

  const showLyrics = usePanel((state) => state.showLyrics)
  const showChords = usePanel((state) => state.showChords)
  const showSections = usePanelAsideStore((state) => state.showSections)

  const [totalListenTime, setTotalListenTime] = useState(0)
  const [startTime, setStartTime] = useState<number | null>(null)

  useUnmount(() => {
    return

    // posthog: disabled for now
    const finalListenTime = Math.round((totalListenTime || 0) / 1000)

    sendEventPostHog({
      name: 'mixer:session_end',
      category: 'engagement',
      customAttributes: {
        created_at: visitedAt?.toISOString(),
        task_id: taskId,
        mixer_session_id: v4(),
        final_mode: getDisplayType({ showLyrics, showChords, showSections }),
        total_playback_time: finalListenTime,
        total_mixer_session_time: getTotalTimeSpent(visitedAt?.toISOString())
      }
    })
  })

  return {
    setTotalListenTime,
    totalListenTime,
    setStartTime,
    startTime
  }
}
